import useUser from '@/redux/hooks/useUser';
import Cookies from 'js-cookie';
import { useEffect } from 'react';
/**
 * Custom hook to manage user authentication state.
 * This hook checks if the user is authenticated based on the presence of a token in cookies.
 * If the user is authenticated but the token is missing, it logs the user out.
 * @returns {void}
 */
export default function useAuth() {
  const { user, logOut } = useUser();
  const isAuthenticated = user.isAuthenticated;

  useEffect(() => {
    const hasToken = !!Cookies.get('access_token');

    if (isAuthenticated && !hasToken) {
      logOut();
    }
  }, [isAuthenticated, logOut]);
}
